import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { downloadFile } from "../utils/downloadFile";

const fetchDownloadCode = async (id, name, isMobile) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  try {
    const downloadUrl = `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=genCode&companyid=${user.companyid}&testcaseid=${id}&testcasename=${name}`;
    // Web test cases come back as a zip of generated files; mobile ones are a
    // single source file (.java/.py/.yaml), so never force a .zip name on them.
    await downloadFile(downloadUrl, { filename: isMobile ? name : `${name}.zip` });
  } catch (error) {
    console.log(error.response?.data?.error || error);
    throw error;
  }
};

const useDownloadCodeQuery = (id, name, isMobile = false) => {
  return useQuery({
    queryKey: ["downloadcode", id],
    queryFn: () => fetchDownloadCode(id, name, isMobile),
    retry: true,
    enabled: false,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};

export default useDownloadCodeQuery;
